import React, { useEffect } from "react";
import ContactSection from "../sections/ContactSection";

const ContactPage = () => {
	useEffect(() => { window.scrollTo(0, 0); }, []);

	return (
		<div className="page-spacer">
			<div className="page-grid-bg" />
			<div className="page-orb-1" />
			<div className="page-orb-2" />
			<div className="page-orb-3" />
			<ContactSection />
		</div>
	);
};

export default ContactPage;
